import { trigger, animate, transition, group, query, style } from '@angular/animations';

export const homeAnimations =
  trigger( 'homeAnimations', [
    transition( ':enter', [
      // initial states
      query( '.home-intro', style( { opacity: 0 } ), { optional: false } ),
      query( '.cell-text', style( { opacity: 0, transform: 'translateY(-20px)' } ), { optional: true } ),
      query( '.cell-content-preview', style( { opacity: 0, transform: 'translateY(-20px)' } ), { optional: true } ),
      query( '.jubilee-bubble-wrapper', style( { opacity: 0, transform: 'scale(0.8)' } ), { optional: true } ),
      group( [
        // enter states
        query( '.home-intro', [
          animate( '500ms 1000ms ease-out', style( { opacity: 1 } ) )
        ], { optional: false } ),
        query( '.cell-text', [
          animate( '500ms 1700ms ease-out', style( { opacity: 1, transform: 'translateY(0)' } ) )
        ], { optional: false } ),
        query( '.cell-content-preview', [
          animate( '500ms 2200ms ease-out', style( { opacity: 1, transform: 'translateY(0)' } ) )
        ], { optional: false } ),
        query( '.jubilee-bubble-wrapper', [
          animate( '800ms 2250ms cubic-bezier(0.68, -0.55, 0.265, 1.55)', style( { opacity: 1, transform: 'scale(1)' } ) )
        ], { optional: true } ),
      ] )
    ] ),
  ] );
